import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { useLiveChat } from "./Utils/Chat/liveChat";
import { useGoogleAnalytics } from "./Utils/GoogleAnalytics/analytics";
import { Routes } from "./Utils/Router/Routes";
import { useSentryTracking } from "./Utils/SentryErrorTracking/tracking";
import "./App.less";

function App() {
  //Here we are initializing our google analytics
  // NOTE:
  // If we want to call any event in any component,
  // you can fire custom events from any component you like by just importing and calling the sendEvent function from the googleAnalytics.js file.
  useGoogleAnalytics();
  useSentryTracking();
  useLiveChat();

  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
